module.exports = __webpack_public_path__ + "static/media/04.12.e58df3b7.webp";